import React from "react";
import useForm from "../../../../hooks/useForm";
import { transformToFormValues } from "../../../../services/formServiceFunctions";
import { persist } from "../../../../services/Persist/persisterService";
import { getRequiredFields } from "../../../../services/StatusChangeValidators/statusChangeValidators";
import _ from "lodash";
import FormElement from "../FormElement";
import SubmitButton from "../../../Button/SubmitButton";
import { getFormDefinition } from "../../../../services/Product/ProductService/productService";
import CaseDetailsSpecialActions from "./CaseDetailsSpecialActions";
import ContentBox from "../../../ContentBox/ContentBox";
import { UseForm } from "../../../../types/UseForm";
import { useCurrentUser } from "../../../../provider/CurrentUserProvider";
import { ProductUnion } from "../../../../types/ProductUnion";

interface CaseDetailsFormProps {
  product: ProductUnion;
  headline?: string;
  refreshCase: () => Promise<void>;
}

export default function CaseDetailsForm({ product, refreshCase, headline = "Details zum Fall" }: CaseDetailsFormProps) {
  const initialValues = { [product.productClassName]: transformToFormValues(product) };
  const currentUser = useCurrentUser();
  const onSubmit = async ({ values }: { values: UseForm["values"] }) => {
    await persist(values, product);
    await refreshCase();
  };

  const useFormProps = useForm({
    initialValues,
    onSubmit,
    identifier: product,
  });

  const mandatoryFields = getRequiredFields(product);
  const formDefinition = getFormDefinition(product, currentUser);

  return (
    <ContentBox headline={headline}>
      <form onSubmit={useFormProps.handleSubmit}>
        {_.map(formDefinition[product.stage || 10], (formElementProps) => {
          return (
            <FormElement
              product={product}
              key={formElementProps.path}
              {...formElementProps}
              {...useFormProps}
              mandatoryFields={mandatoryFields}
            />
          );
        })}
        <SubmitButton
          error={_.keys(useFormProps.errors).length > 0}
          isLoading={useFormProps.isLoading}
          disabled={_.keys(useFormProps.touchedValues).length === 0}
          variant={"contained"}
          type={"submit"}
          sx={{ marginTop: "1rem" }}
        >
          Speichern
        </SubmitButton>
      </form>
      <CaseDetailsSpecialActions product={product} />
    </ContentBox>
  );
}
